import { render, staticRenderFns } from "./ImageWithBorder.vue?vue&type=template&id=629068ea&"
import script from "./ImageWithBorder.vue?vue&type=script&lang=ts&"
export * from "./ImageWithBorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports